import React from 'react';

const BrandingStyles = () => {

  return (
    // <style jsx global>{`
    <style>{`
      /* CSS переменные уже установлены в BrandingProvider */

      /* Fallback значения уже установлены в variables.css */
      
      /* Повышаем специфичность всех стилей брендинга */
      body {
        /* Базовые стили для body */
      }

      /* ===== ОСНОВНЫЕ ЭЛЕМЕНТЫ ===== */
      body .btn-primary {
        background-color: var(--main-color, #4783ed) !important;
        border-color: var(--main-color, #4783ed) !important;
        color: var(--text-on-primary, #ffffff) !important;
      }

      body .btn-primary:hover {
        background-color: var(--hover-color);
        border-color: var(--hover-color);
      }

      body .btn-secondary {
        background-color: var(--secondary-color);
        border-color: var(--secondary-color);
        color: var(--text-active);
        fill: var(--text-active);
      }

      body .btn-secondary:hover {
        background-color: var(--hover-color);
        border-color: var(--hover-color);
      }

      body .btn.active, body .btn:active {
        color: var(--text-active);
      }

      /* Hover для всех кнопок */
      body .btn:hover {
        background-color: var(--hover-color) !important;
        border-color: var(--hover-color) !important;
        color: var(--text-on-primary) !important;
      }

      /* ===== НАВИГАЦИЯ ===== */
      body .navbar-container {
        background-color: var(--main-color);
      }

      body .sidebar-list {
        color: var(--text-color);
        background-color: var(--background-light);
      }

      body .sidebar-list:hover {
        background-color: var(--hover-color) !important;
      }

      body .sidebar-list.active {
        background-color: var(--secondary-color) !important;
      }

      body .sidebarNavigation ul li.active {
        background-color: var(--secondary-color) !important;
      }

      body .sidebarNavigation ul li.active a {
        color: var(--text-active);
      }

      body .sidebarNavigation ul li.active a .sidebar-icon {
        color: var(--text-active);
      }

      body .sidebarNavigation ul li.active a .sidebar-title {
        color: var(--text-active);
      }

      /* Hover styles for sidebar navigation */
      body .sidebarNavigation ul li:hover {
        background-color: var(--hover-color) !important;
        // color: var(--text-on-primary) !important;
      }

      body .sidebarNavigation ul li:hover a .sidebar-icon,
      body .sidebarNavigation ul li:hover .ionIcon,
      body .sidebarNavigation ul li:hover a .sidebar-icon *,
      body .sidebarNavigation ul li:hover .ionIcon *,
      body .sidebarNavigation ul li:hover a .sidebar-icon svg,
      body .sidebarNavigation ul li:hover .ionIcon svg,
      body .sidebarNavigation ul li:hover a .sidebar-icon svg path,
      body .sidebarNavigation ul li:hover .ionIcon svg path {
        // color: var(--text-on-primary) !important;
      }

      body .sidebarNavigation ul li:hover a .sidebar-title {
        // color: var(--text-on-primary) !important;
      }

      /* ===== БУРГЕР-МЕНЮ ===== */
      /* Цвет иконки бургер-кнопки управляется переменными и по умолчанию черный */
      body .toggle .toggleButton line {
        color: var(--burger-color, #000);
      }

      body .toggle:hover .toggleButton line {
        color: var(--burger-hover-color, var(--burger-color, #000));
      }

      body .toggle.active .toggleButton line {
        color: var(--burger-active-color, var(--burger-color, #000));
      }

      /* На desktop в закрытом состоянии используется цвет hover */
      @media (min-width: 1282px) {
        body .toggle:not(.active) .toggleButton line {
          color: var(--burger-hover-color, var(--burger-color, #000));
        }
      }

      /* Гарантируем, что SVG крестика использует текущий цвет */
      body .toggle .toggleButton svg,
      body .toggle .toggleButton svg path line {
        stroke: currentColor;
      }

      /* ===== ПОЛЯ ВВОДА ===== */
      /* Все стандартные input типы */
      input[type="text"], input[type="email"], input[type="password"], input[type="number"], 
      input[type="tel"], input[type="url"], input[type="search"], input[type="date"], 
      input[type="time"], input[type="datetime-local"], input[type="color"], input[type="range"],
      body input[type="file"], body input[type="hidden"], body input[type="checkbox"], body input[type="radio"],
      body textarea, body select {
        background-color: var(--input-background) ;
        color: var(--input-text) ;
        border-color: var(--input-border) ;
      }

      /* Кастомные input компоненты */
      .input, .input-field, .form-input, .form-control, .form-group input,
      .custom-input, .text-input, .email-input, .password-input, .number-input,
      body .search-input, body .date-input, body .time-input, body .textarea, body .select,
      body [class*="input"], body [class*="Input"], body [class*="field"], body [class*="Field"] {
        background-color: var(--input-background) ;
        color: var(--input-text) ;
        border-color: var(--input-border) ;
      }

      /* Placeholder для всех input типов */
      input[type="text"]::placeholder, input[type="email"]::placeholder, 
      input[type="password"]::placeholder, input[type="number"]::placeholder,
      input[type="tel"]::placeholder, input[type="url"]::placeholder, 
      input[type="search"]::placeholder, textarea::placeholder {
        color: var(--input-placeholder) ;
      }

      /* Placeholder для кастомных input */
      .input::placeholder, .input-field::placeholder, .form-input::placeholder, 
      .form-control::placeholder, .custom-input::placeholder, .text-input::placeholder,
      .email-input::placeholder, .password-input::placeholder, .number-input::placeholder,
      .search-input::placeholder, .date-input::placeholder, .time-input::placeholder,
      .textarea::placeholder, .select::placeholder,
      [class*="input"]::placeholder, [class*="Input"]::placeholder,
      [class*="field"]::placeholder, [class*="Field"]::placeholder {
        color: var(--input-placeholder) ;
      }

      /* Focus для всех стандартных input */
      input[type="text"]:focus, input[type="email"]:focus, input[type="password"]:focus, 
      input[type="number"]:focus, input[type="tel"]:focus, input[type="url"]:focus, 
      input[type="search"]:focus, input[type="date"]:focus, input[type="time"]:focus, 
      input[type="datetime-local"]:focus, textarea:focus, select:focus {
        background-color: var(--input-focus-background) ;
        color: var(--input-text) ;
      }

      /* Focus для кастомных input - БЕЗ обводки */
      .input:focus, .input-field:focus, .form-input:focus, .form-control:focus,
      .custom-input:focus, .text-input:focus, .email-input:focus, .password-input:focus,
      .number-input:focus, .search-input:focus, .date-input:focus, .time-input:focus,
      .textarea:focus, .select:focus,
      [class*="input"]:focus, [class*="Input"]:focus,
      [class*="field"]:focus, [class*="Field"]:focus {
        background-color: var(--input-focus-background) ;
        border-color: var(--input-focus-border) ;
        color: var(--input-text) ;
        outline: none ;
        box-shadow: none ;
      }

      /* Дополнительные универсальные селекторы для всех input */
      input, textarea, select {
        background-color: var(--input-background) ;
        color: var(--input-text) ;
        border-color: var(--input-border) ;
        outline: none ;
        box-shadow: none ;
      }

      input::placeholder, textarea::placeholder {
        color: var(--input-placeholder) ;
      }

      input:focus, textarea:focus, select:focus {
        background-color: var(--input-focus-background) ;
        border-color: var(--input-focus-border) ;
        color: var(--input-text) ;
        outline: 2px solid var(--input-focus-border) ;
        outline-offset: 2px ;
        box-shadow: 0 0 0 2px var(--input-focus-border) ;
      }

      /* Hover для полей ввода */
      input:hover, textarea:hover, select:hover {
        border-color: var(--hover-color) ;
      }

      /* Специальные классы для полей ввода */
      .form-control, .form-input, .input-field {
        background-color: var(--input-background) ;
        color: var(--input-text) ;
        border-color: var(--input-border) ;
      }

      .form-control::placeholder, .form-input::placeholder, .input-field::placeholder {
        color: var(--input-placeholder) ;
      }

      .form-control:focus, .form-input:focus, .input-field:focus {
        background-color: var(--input-focus-background) ;
        border-color: var(--input-focus-border) ;
        color: var(--input-text) ;
        outline: none ;
        box-shadow: none ;
      }

      /* ===== ТЕКСТ ===== */
      body, .content, .navbar-container {
        color: var(--text-color) ;
        background-color: var(--background-color) ;
      }

      /* ===== ТЕКСТ ДЛЯ РАЗНЫХ ОБЛАСТЕЙ ===== */
      /* Сайдбар */
      .sidebarNavigation, .sidebarNavigation * {
        color: var(--text-sidebar) ;
      }

      /* Неактивные иконки в сайдбаре */
      .sidebarNavigation .sidebar-icon,
      .sidebarNavigation .ionIcon,
      .sidebarNavigation .sidebar-icon *,
      .sidebarNavigation .ionIcon * {
        color: var(--text-inactive) ;
      }

      /* Активные иконки в сайдбаре */
      .sidebarNavigation ul li.active .sidebar-icon,
      .sidebarNavigation ul li.active .ionIcon,
      .sidebarNavigation ul li.active .sidebar-icon *,
      .sidebarNavigation ul li.active .ionIcon * {
        color: var(--text-on-primary) ;
      }

      /* Футер */
      footer, .footer, .footer * {
        color: var(--text-footer) ;
      }

      /* Хедер */
      header, .header, .navbar, .navbar * {
        color: var(--text-header) ;
      }

      /* Основная часть страницы */
      .main-content, .content, .page-content, .main-content * {
        color: var(--text-main) ;
      }

      h1, h2, h3, h4, h5, h6 {
        color: var(--text-dark-color) ;
      }

      h1.active, h2.active, h3.active, h4.active, h5.active, h6.active {
        color: var(--text-active) ;
      }

      p, span, div {
        color: var(--text-color) ;
      }

      .text-light {
        color: var(--text-light-color) ;
      }

      .text-dark {
        color: var(--text-dark-color) ;
      }

      .text-active {
        color: var(--text-active) ;
      }

      /* ===== АКТИВНЫЕ ЭЛЕМЕНТЫ ===== */
      .active, .active-item, .current-page, .selected {
        color: var(--text-active) ;
      }

      .nav-item.active, .nav-link.active {
        color: var(--text-active) ;
      }

      .tab.active, .tab-pane.active {
        color: var(--text-active) ;
      }

      .menu-item.active, .sidebar-item.active {
        color: var(--text-active) ;
      }

      .header-active, .title-active {
        color: var(--text-active) ;
      }

      /* ===== ФОНЫ ===== */
      .content, .wrapper {
        background-color: var(--background-color) ;
      }

      .card, .panel, .modal-content {
        background-color: var(--background-light) ;
        border-color: var(--border-color) ;
      }

      .card:hover, .panel:hover {
        background-color: var(--hover-color) ;
        color: var(--text-on-primary) ;
      }

      .bg-light {
        background-color: var(--background-light) ;
      }

      .bg-dark {
        background-color: var(--background-dark) ;
      }

      /* ===== ОБВОДКИ ===== */
      .form-control, .input, input, textarea, select {
        border-color: var(--border-color) ;
        background-color: var(--background-light) ;
        color: var(--text-color) ;
      }

      .form-control:focus, .input:focus, input:focus, textarea:focus, select:focus {
        border-color: var(--border-focus) ;
        box-shadow: 0 0 0 2px rgba(71, 131, 237, 0.25) ;
      }

      .border {
        border-color: var(--border-color) ;
      }

      .border-light {
        border-color: var(--border-light) ;
      }

      .border-dark {
        border-color: var(--border-dark) ;
      }

      /* ===== СОСТОЯНИЯ ===== */
      .disabled, .btn:disabled {
        color: var(--disabled-color) ;
        background-color: var(--disabled-background) ;
        border-color: var(--border-light) ;
      }

      /* ===== УВЕДОМЛЕНИЯ ===== */
      .alert-success, .notification-success {
        background-color: var(--success-background) ;
        color: var(--success-color) ;
        border-color: var(--success-color) ;
      }

      .alert-error, .alert-danger, .notification-error {
        background-color: var(--error-background) ;
        color: var(--error-color) ;
        border-color: var(--error-color) ;
      }

      .alert-warning, .notification-warning {
        background-color: var(--warning-background) ;
        color: var(--warning-color) ;
        border-color: var(--warning-color) ;
      }

      .alert-info, .notification-info {
        background-color: var(--info-background) ;
        color: var(--info-color) ;
        border-color: var(--info-color) ;
      }

      /* ===== ССЫЛКИ ===== */
      a, .link {
        color: var(--link-color) ;
      }

      a:hover, .link:hover {
        color: var(--hover-color) ;
      }

      a.active, .link.active {
        color: var(--text-active) ;
      }

      /* ===== ТЕНИ ===== */
      .shadow, .card-shadow {
        box-shadow: 0 2px 4px var(--shadow-color) ;
      }

      .shadow-lg {
        box-shadow: 0 4px 8px var(--shadow-color) ;
      }

      /* ===== АКТИВНЫЕ ЭЛЕМЕНТЫ ===== */
      .navbar-container .active {
        color: var(--text-active) ;
      }

      #navbarSupportedContent>ul>li.active>a {
        color: var(--text-on-primary) ;
        // color: var(--text-active) ;
      }

      /* ===== СКРОЛЛБАР ===== */
      ::-webkit-scrollbar-thumb {
        background-color: var(--main-color) ;
      }

      ::-webkit-scrollbar-thumb:hover {
        background-color: var(--hover-color) ;
      }

      /* ===== ДИНАМИЧЕСКИЙ КОНТЕНТ ===== */
      .dynamic-homepage-content {
        --brand-primary: var(--main-color);
        --brand-secondary: var(--secondary-color);
        --brand-text: var(--text-color);
        --brand-background: var(--background-color);
      }

      /* ===== СПЕЦИАЛЬНЫЕ ЭЛЕМЕНТЫ ===== */
      .title p {
        -webkit-text-stroke: 2px var(--main-color) ;
        color: var(--text-on-primary) ;
      }

      /* ===== ПЕРЕХОДЫ ===== */
    `}</style>
  );
};

export default BrandingStyles;
// * {
// transition: color 0.3s ease, background-color 0.3s ease, border-color 0.3s ease ;
// }